export class OrderPayMin {
    payTypeId;
    amountParcel;
    value;
    orderId?;
    date?;
    cashierID?;
    protocolId?;
    notes?;
    transactionIdentifier?;
    discountOS?;
}
